import React, { ChangeEvent } from "react";
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";

// Components
import CurrentAvailableAppointments from "./CurrentAvailableAppointments/CurrentAvailableAppointments";
import CustomCalendar from "~/components/_uikit/CustomCalendar/CustomCalendar";
import CalendarTab from "~/components/_uikit/CalendarTab/CalendarTab";
import AdditionalHospitals from "~/components/common/AdditionalHospitals/AdditionalHospitals";
import NoFountEntity from "~/components/common/NoFoundEntity/NoFountEntity";
// Styles
import s from "./ScheduleAppointmentSection.module.scss";
// Hooks
import { useStore } from "~/hooks/useStore";
// Types
import RootStore from "~/store/RootStore";
// Utils
import { goToHelpPage } from "~/utils/helpers";
import ROUTES from "~/utils/routes";

interface Props {
  date: Date;
  changeDate: (value: Date) => void;
  formattedDate: string;
  formattedDateWeek: string;
}

const ScheduleAppointmentSection: React.FC<Props> = observer(
  ({ date, changeDate }) => {
    const store: RootStore = useStore();
    const navigate = useNavigate();
    const allowedDates = store.appointmentStore.ticketDates;
    const currentlyTicketTimeSlots =
      store.appointmentStore.currentlyTicketTimeSlots;
    const hospitals = store.hospitalStore.additionalHospitals;

    const changeHospital = (id: number) => {
      store.hospitalStore.setCurrentHospital(id);
      navigate(ROUTES.SPECIALTIES.PATHNAME, { replace: true });
    };

    return (
      <>
        <h2 className="headline-2">Расписание работы:</h2>

        <div className={s.scheduleWrapper}>
          <aside className={s.scheduleSection}>
            <div className={s.calendarTabWrapper}>
              <CalendarTab
                date={date}
                changeDate={changeDate}
                allowedDates={allowedDates}
              />
            </div>

            <div className={s.calendarWrapper}>
              <CustomCalendar
                value={date}
                onChange={
                  /* eslint-disable-next-line */
                  (value: Date, event: ChangeEvent<HTMLInputElement>) => changeDate(value)
                }
                allowedDates={allowedDates}
              />
            </div>
          </aside>

          <section className={s.scheduleCardsWrapper}>
            {currentlyTicketTimeSlots.length !== 0 ? (
              <CurrentAvailableAppointments
                tickets={currentlyTicketTimeSlots}
              />
            ) : (
              <div className={s.noFoundEntity}>
                <NoFountEntity
                  hideControls
                  title={"Нет приёма для записей в выбранный день"}
                  subtitle={"Попробуйте выбрать другую ближайшую дату"}
                  onClick={goToHelpPage}
                />
              </div>
            )}
          </section>

          {!store.cityStore.isMoscowRegion && (
            <section className={s.additionalHospitals}>
              <AdditionalHospitals
                hospitals={hospitals}
                onClick={changeHospital}
              />
            </section>
          )}
        </div>
      </>
    );
  }
);

export default ScheduleAppointmentSection;
